<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path d="M7 10L12.5 15L18 10" stroke="currentColor" />
  </svg>
</template>
